import { getPropertyInPath } from './generalFunctions';
import { findings } from './mapCV';

const liveArMetrics = [
  'acne',
  'darkSpots',
  'eyeColor',
  'darkcircles',
  'dullSkin',
  'eyebags',
  'faceShape',
  'freckles',
  'hyperpigmentation',
  'melasma',
  'poreDilation',
  'radiance',
  'redness',
  'skinAge',
  'skinFirmness',
  'skinFoundation',
  'skintone',
  'skinSagging',
  'skinShine',
  'skinUndertone',
  'smoothness',
  'texture',
  'unevenSkinTone',
  'wrinkles',
  'nasolabialFolds',
  'marionetteLines',
  'underEyeLines',
  'foreheadLines',
  'wrinklesForeheadEyes'
];

const getSubfindingFromData = (json, parent, locationsToUse) => {
  if (!json || !Array.isArray(json)) {
    return null;
  }

  const parentMetric = json.find((metric) => metric.description === parent);
  if (
    // eslint-disable-next-line camelcase
    !parentMetric?.measurement_locations ||
    !Array.isArray(parentMetric.measurement_locations) ||
    parentMetric.measurement_locations.length === 0
  ) {
    return null;
  }

  const result = parentMetric.measurement_locations.reduce(
    (acc, part) => {
      if (!locationsToUse.includes(part?.description)) {
        return acc;
      }
      return {
        sum: acc.sum + part.value,
        count: acc.count + 1,
        measurement_locations: [...acc.measurement_locations, part],
      };
    },
    {
      count: 0,
      sum: 0,
      measurement_locations: [],
    },
  );
  const value = result.count > 0 ? result.sum / result.count : 0;

  console.log(result.sum, result.count, value);
  return { value, measurement_locations: result.measurement_locations };
};

const consoleLogger = (message) => console.log(`%${message}`, 'color: orange');

export const getLiveArMetrics = (metricResults, metricList = null, metricValues, logger = consoleLogger) => {
  const metrics = {};

  const metricsToUse = metricList || liveArMetrics;

  metricsToUse.forEach((metricName) => {
    const metricFinding = findings[metricName];
    if (!metricFinding?.parent && !metricFinding?.path) {
      logger(`Visualisation for ${metricName} not implemented`);
      return;
    }

    const metricData = metricFinding?.parent ?
      getSubfindingFromData(metricResults, metricFinding.parent.name, metricFinding.parent.measurements)
      : getPropertyInPath(metricResults, metricFinding.path);

    if (!metricData) {
      return;
    }
    metrics[metricName] = metricData;
  });

  const metricsWithOverall =
    metricValues?.overall !== undefined
      ? {
        ...metrics,
        overall: {
          description: 'overall',
          value: metricValues.overall,
        },
      }
      : metrics;

  return metricsWithOverall;
};
